import React from 'react';
import { EventProvider } from '@pinwheel/origami';
import eventQueue from '../../events/queue';
var UIEvents = function (_a) {
    var children = _a.children;
    return (React.createElement(EventProvider, { value: function (data) {
            eventQueue.emit('ui', { data: data });
        } }, children));
};
export default UIEvents;
